import React from 'react';
import cx from 'classnames';
import { Validate, useFormContext } from 'react-hook-form';
import { AppSumoFormArgs } from '.';
import { Input, InputProps } from './Input';
import { ErrorMessage } from '@hookform/error-message';
import { FieldError } from '~/App/Components/Forms';

export interface InputGroupProps extends Omit<InputProps, 'inputRef'> {
  label: string;
  className?: string;
  labelClassName?: string;
  inputClassName?: string;
  errorLabelClassName?: string;
  validate?: Validate | Record<string, Validate>;
}

export function InputGroup({
  label,
  className,
  labelClassName,
  inputClassName,
  errorLabelClassName,
  validate,
  ...inputProps
}: InputGroupProps) {
  // eslint-disable-next-line @typescript-eslint/unbound-method
  const { register, errors } = useFormContext<AppSumoFormArgs>();

  const inputName = inputProps.name ?? '';

  return (
    <div className={cx(className, 'flex flex-col gap-y-1.5 w-full')}>
      <span className={cx(labelClassName, 'text-base font-bold')}>{label}</span>
      <Input
        className={inputClassName}
        inputRef={register({
          required: `${label} is required`,
          validate,
        })}
        {...inputProps}
      />
      <ErrorMessage
        className={cx(
          errorLabelClassName,
          '!text-sm !v2-text-orange-600 v2-animate-fade-in-150'
        )}
        name={inputName}
        errors={errors}
        as={FieldError}
      />
    </div>
  );
}
